<template>
  <dash-board-layout :active="8" :fulid="true">
    <div class="verification section-padding">
      <div class="container h-100">
        <div class="row justify-content-center h-100 align-items-center">
          <div class="col-xl-4 col-md-6" v-if="!hasNumber">
            <div class="auth-form card">
              <div class="card-header">
                <h4 class="card-title">Please input your card number</h4>
              </div>

              <div class="card-body">
                <div class="form-row">
                  <div class="form-group col-xl-12">
                    <label class="mr-sm-2">Card number</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="baseInfo.cardNum"
                      placeholder="5658 4258 6358 4756"
                    />
                  </div>

                  <div class="text-center col-12">
                    <button
                      type="button"
                      :disabled="loading"
                      @click="openForm()"
                      class="btn btn-success pl-5 pr-5"
                    >
                      Continue
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-xl-4 col-md-6" v-if="hasNumber && !isCreditCard">
            <div class="auth-form card">
              <div class="card-header">
                <el-page-header
                  @back="editCardNum"
                  title=""
                  content="Link a debit card"
                >
                </el-page-header>
                <!-- <h4 class="card-title">
                  <a @click="editCardNum">Back </a> | Link a debit card
                </h4> -->
              </div>
              <div class="card-body">
                <form @submit.prevent="formSubmit" class="identity-upload">
                  <div class="form-row">
                    <div class="form-group col-xl-12">
                      <label class="mr-sm-2">Name on card </label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="baseInfo.name"
                        placeholder="Carla Pascle"
                      />
                    </div>
                    <div class="form-group col-xl-12">
                      <label class="mr-sm-2">Card number </label>
                      <input
                        type="text"
                        class="form-control"
                        disabled
                        v-model="showCardNum"
                        placeholder="5658 4258 6358 4756"
                      />
                    </div>
                    <div class="form-group col-xl-4">
                      <label class="mr-sm-2">Expiration </label>
                      <input
                        type="text"
                        class="form-control"
                        maxlength="2"
                        v-model="baseInfo.exp_month"
                        placeholder="Mon [1-12] "
                      />
                    </div>
                    <div class="form-group col-xl-4">
                      <label class="mr-sm-2">&nbsp;</label>
                      <input
                        type="text"
                        class="form-control"
                        maxlength="4"
                        v-model="baseInfo.exp_year"
                        placeholder="yyyy [2021.]"
                      />
                    </div>
                    <div class="form-group col-xl-4">
                      <label class="mr-sm-2">CVC code </label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="baseInfo.cvc"
                        placeholder="***"
                      />
                    </div>

                    <div class="text-center col-12">
                      <button type="submit" class="btn btn-success pl-5 pr-5">
                        Save
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>

          <div class="col-xl-4 col-md-6" v-if="hasNumber && isCreditCard">
            <div class="auth-form card">
              <div class="card-header">
                <el-page-header
                  @back="editCardNum"
                  title=""
                  content="Link a credit card"
                >
                </el-page-header>
              </div>
              <div class="card-body">
                <form @submit.prevent="formSubmit" class="identity-upload">
                  <div class="form-row">
                    <div class="form-group col-xl-12">
                      <label class="mr-sm-2">Name on card </label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="baseInfo.name"
                        placeholder="Carla Pascle"
                      />
                    </div>
                    <div class="form-group col-xl-12">
                      <label class="mr-sm-2">Card number </label>
                      <input
                        type="text"
                        class="form-control"
                        disabled
                        v-model="showCardNum"
                        placeholder="5658 4258 6358 4756"
                      />
                    </div>
                    <div class="form-group col-xl-4">
                      <label class="mr-sm-2">Expiration </label>
                      <input
                        type="text"
                        class="form-control"
                        maxlength="2"
                        v-model="baseInfo.exp_month"
                        placeholder="Mon [1-12] "
                      />
                    </div>
                    <div class="form-group col-xl-4">
                      <label class="mr-sm-2">&nbsp;</label>
                      <input
                        type="text"
                        class="form-control"
                        maxlength="4"
                        v-model="baseInfo.exp_year"
                        placeholder="yyyy [2021.]"
                      />
                    </div>
                    <div class="form-group col-xl-4">
                      <label class="mr-sm-2">CVC code </label>
                      <input
                        type="text"
                        class="form-control"
                        maxlength="4"
                        v-model="baseInfo.cvc"
                        placeholder="***"
                      />
                    </div>

                    <div class="text-center col-12">
                      <button type="submit" class="btn btn-success pl-5 pr-5">
                        Save
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </dash-board-layout>
</template>
<script>
import DashBoardLayout from "../../components/layouts/DashBoardLayout.vue";
import { add, update } from "../../plugins/api/user_bank_acc";
export default {
  components: { DashBoardLayout },
  data() {
    return {
      showCardNum: "",
      active: "addDebitCard",
      cardType: "no",
      isCreditCard: false,
      hasNumber: false,
      loading: false,
      baseInfo: {
        cardNum: "",
        name: "",
        cvc: "",
        exp_month: "",
        exp_year: "",
      },
      billingDetails: {
        name: "",
        city: "",
        country: "",
        line1: "",
        line2: "",
        district: "",
        postalCode: "",
      },
    };
  },
  methods: {
    formSubmit() {
      // let that = this
      add(this.baseInfo).then((res) => {
        if (res.code == 0) {
          this.$alert(
            "Successfully created, please refine your account information next.",
            "Props",
            {
              confirmButtonText: "Enter",
              type: "success",
              showClose: false,
              closeOnClickModal: false,
              callback: (action) => {
                this.$router.push(
                  `/att-card-info?token=${res.data}&c=${encodeURIComponent(
                    this.$cardop.bankCard(this.baseInfo.cardNum)
                  )}`
                );
              },
            }
          );
        }
      });
      // this.$router.push("/verify-step-6");
    },
    editCardNum() {
      this.hasNumber = false;
    },
    openForm() {
      let that = this;
      if (this.baseInfo.cardNum.length >= 16) {
        let startVal = this.baseInfo.cardNum;
        if (startVal.length > 0) {
          startVal = startVal.substr(0, 1);
        }
        switch (parseInt(startVal)) {
          case 6:
            this.isCreditCard = false;
            this.hasNumber = true;
            this.cardType = "unionpay";
            break;
          case 3:
            this.cardType = "amex";
          case 4:
            this.cardType = "visa";
          case 5:
            this.cardType = "mastercard";
            this.isCreditCard = true;
            this.hasNumber = true;
            this.showCardNum = this.$cardop.fourNums(this.baseInfo.cardNum);
            break;
          default:
            this.cardType = "";
            this.hasNumber = false;
            this.isCreditCard = false;
            this.$Message.warning("Card number has error.");
            break;
        }

        // this.loading = true;
        // setTimeout(() => {
        //   that.loading = false;
        // }, 500);
      } else {
        this.$Message.warning("Card number has error.");
      }
    },
  },
};
</script>
